/**
 * Plan years live here rather than in `lib/` so the seed script can read them:
 * the deploy image only ships `db/` and `scripts/`. App code should import
 * these from `lib/planYears`.
 */
export const DEFAULT_PLAN_YEAR = 2027;

export const SUPPORTED_PLAN_YEARS = [DEFAULT_PLAN_YEAR, 2026] as const;
